import * as types from '../constants/action-types';
import { Entitlements } from '../../../../api/api-entitlements';
import { Profile } from '../../../../api/api-profile';
import _ from 'lodash';


export function fetchEntitlements (accessToken, profile) {
  const ssoId = _.get(profile, 'SSOid', '');
  return dispatch => {
    const query = `created_by_sso_id=${ssoId}&class=HOST_REFERRAL`;

    dispatch({ type: types.ENTITLEMENTS_FETCH_REQUEST, isFetching: true });

    Entitlements.readEntitlementQuery(query, accessToken, (response) => {
      if (400 < response.statusCode) {
        return dispatch({
          type: types.ENTITLEMENTS_FETCH_FAILURE,
          error: response.message,
          isFetching: false
        });
      }

      return dispatch({
        type: types.ENTITLEMENTS_FETCH_SUCCESS,
        entitlementsArray: response.entitlements,
        isFetching: false
      });
    });
  };
}

export function fetchGuestReferralEntitlements (ssoId, accessToken) {
  return dispatch => {
    const query = `created_by_sso_id=${ssoId}&class=GUEST_REFERRAL`;
    dispatch({ type: types.FETCH_GUEST_REFERRAL_ENTITLEMENTS_REQUEST, isFetching: true });
    Entitlements.readEntitlementQuery(query, accessToken, (response) => {
      if (400 < response.statusCode) {
        return dispatch({
          type: types.FETCH_GUEST_REFERRAL_ENTITLEMENTS_FAILURE,
          error: response,
          isFetching: false
        });
      }

      return dispatch({
        type: types.FETCH_GUEST_REFERRAL_ENTITLEMENTS_SUCCESS,
        entitlementsArray: response,
        isFetching: false
      });
    });
  };
}

export function fetchEntitlementsDetails (query) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({ type: types.ENTITLEMENTS_FETCH_REQUEST, isFetching: true });

      Entitlements.readEntitlement(query, (response) => {
        if (400 <= response.statusCode) {
          dispatch({
            type: types.ENTITLEMENTS_FETCH_FAILURE,
            error: response.message,
            isFetching: false
          });
          return reject(response);
        }

        dispatch({
          type: types.ENTITLEMENTS_FETCH_SUCCESS,
          referralData: response,
          isFetching: false
        });
        return resolve(response);
      });
    });
  };
}

export function fetchUserEntitlements (ssoId, token) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({ type: types.ENTITLEMENTS_FETCH_REQUEST, isFetching: true });

      Entitlements.readUserEntitlement(ssoId, token, (response) => {
        if (400 <= response.statusCode) {
          dispatch({
            type: types.ENTITLEMENTS_FETCH_FAILURE,
            error: response.message,
            isFetching: false
          });
          return reject(response);
        }

        dispatch({
          type: types.ENTITLEMENTS_FETCH_SUCCESS,
          referralData: response,
          isFetching: false
        });
        return resolve(response);
      });
    });
  };
}

export function fetchProfileForEntitlements (ssoid) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      const profilePath = `/v1/profiles/${ssoid}`;

      // Dispatch action that profile is being requested.
      // dispatch(profileRequest());

      // Request profile.
      Profile.read(profilePath, null, (response) => {
        // No profile.
        if (response.error) {
          return reject(response);
          // return dispatch(profileFailure());
        }

        // Successful profile.
        // return dispatch(preProfileSuccess(accessToken, response));
        return resolve(response);
      });
    });
  };
}
